import { CampaignIdentifierType, CampaignPost } from '@anytag/graphql';
import { PostModal } from '../shared';
import { EngagementPostDetailsTemplate } from '../engagement-post-details-modal';
import { MarketplacePostDetailsTemplate } from '../marketplace-post-details-modal';

export interface PostDiscoveryDetailsModalProps {
  posts: readonly CampaignPost[];
}
export const PostDiscoveryDetailsModal = ({ posts = [] }: PostDiscoveryDetailsModalProps) => (
  <PostModal posts={posts}>
    {({ selectedPost }) =>
      selectedPost.campaignIdentifier.campaignType === CampaignIdentifierType.ENGAGEMENT ? (
        <EngagementPostDetailsTemplate />
      ) : (
        <MarketplacePostDetailsTemplate hidePostHistory />
      )
    }
  </PostModal>
);
